export default class TypeStateInsurance {
  id!: number
  policy_state!: string
  isEdit!: boolean
}
